/* Author: Christen Perey */
import { createRouter, createWebHistory } from "vue-router";

// Import Components
import AboutOverview from "@/components/AboutOverview.vue";
import ExperienceOverview from "@/components/ExperienceOverview.vue";

// Define Routes for Vue-Router
const routes = [
    {
        path: "/",
        name: "AboutOverview",
        component: AboutOverview
    },
    {
        path: "/experience",
        name: "ExperienceOverview",
        component: ExperienceOverview
    }
];

const router = createRouter({
    history: createWebHistory(),
    routes
});

export default router;